import React, { useEffect, useState } from "react"
import { getStockItems } from "@/components/PartsViewer/v2/helper"
import ButtonLabel from "@/components/PartsViewer/v2/ButtonLable/Index"
import PropTypes from "prop-types"

const CartButton = props => {
  const {
    isAddedFlag,
    cartQuantity,
    handlerButton,
    swatches,
    list = false,
  } = props
  const [item, setItem] = useState(null)

  useEffect(() => {
    if (swatches) {
      getSwatchesDetails(swatches)
    }
  }, [swatches])

  const getSwatchesDetails = async arg => {
    const filterItems = arg.filter(v => v?.swatch !== "swatch_NA")
    const updatedList = filterItems.length === 0 ? arg : filterItems
    const resp = await getStockItems(updatedList)
    if (resp) {
      setItem(resp)
    }
  }

  const buttonClass = isAddedFlag ? "cart-added" : "active-btn"
  const isDisabled = item?.discontuned && !item?.outofStock
  const listViewClass = list ? "grid-button list-button" : "grid-button "
  const listViewtext = list ? "Notify" : "Notify Me"
  const stockText = item?.outofStock && !item?.stock ? listViewtext : "Add"
  const disabledVal = isDisabled && !item?.stock
  const buttontext = disabledVal ? "Discontinued" : stockText
  return (
    <div className={`button-groups-${list ? "list-btns" : ""}`}>
      <div
        className={
          listViewClass +
          ` button-add-carts ${disabledVal ? "disabled-btn" : buttonClass}`
        }
      >
        <button
          type="button"
          className={`fs-18 fw-500 add-to-cart d-flex align-items-center justify-content-center ${
            list ? "list right-screen" : ""
          }`}
          onClick={() => handlerButton(!disabledVal)}
        >
          {isAddedFlag ? (
            <ButtonLabel cartQuantity={cartQuantity} list={list} />
          ) : (
            buttontext
          )}
        </button>
      </div>
    </div>
  )
}

CartButton.propTypes = {
  isAddedFlag: PropTypes.string.isRequired,
  cartQuantity: PropTypes.string.isRequired,
  handlerButton: PropTypes.func.isRequired,
  swatches: PropTypes.object.isRequired,
  list: PropTypes.bool.isRequired,
}

export default CartButton
